<template>
  <div id="custom-tooltip" class="tooltip__main--container">
    <!-- Tooltip info displayed on hover -->
    <div class="tooltip__info--main-container" :style="containerStyle">
      <div class="tooltip__arrow--box" :class="arrowClass">
        <slot name="info"></slot>
      </div>
    </div>
    <!-- Tooltip actual content -->
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  props: {
    // `placement` props can be: `top`, `bottom`, `left`, `right`
    placement: {
      type: String,
      default: "top"
    },
    floating: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tooltipHeight: 0,
      tooltipWidth: 0
    };
  },
  mounted() {
    const mainContainer = document.getElementById("custom-tooltip");
    this.tooltipHeight = mainContainer && mainContainer.offsetHeight;
    this.tooltipWidth = mainContainer && mainContainer.offsetWidth;
  },
  computed: {
    containerStyle() {
      if (this.floating) {
      }
      // ===== Tooltip info placement =====
      // === TOP ===
      if (this.placement === "top") {
        return {
          bottom: `${this.tooltipHeight + 10}px`,
          left: "50%",
          transform: "translateX(-50%)"
        };
        // === BOTTOM ===
      } else if (this.placement === "bottom") {
        return {
          top: `${this.tooltipHeight + 10}px`,
          left: "50%",
          transform: "translateX(-50%)"
        };
        // === LEFT ===
      } else if (this.placement === "left") {
        return {
          right: `${this.tooltipWidth + 10}px`,
          top: "50%",
          transform: "translateY(-50%)"
        };
        // === RIGHT ===
      } else if (this.placement === "right") {
        return {
          left: `${this.tooltipWidth + 10}px`,
          top: "50%",
          transform: "translateY(-50%)"
        };
      }
    },
    arrowClass() {
      return `tooltip__arrow--placement-${this.placement}`;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/css/_colors.scss";
.tooltip__main--container {
  position: relative;
  cursor: default;
  margin: 0;
  padding: 0;
  width: auto;
  display: inline-block;
}

.tooltip__main--container:hover .tooltip__info--main-container {
  visibility: visible;
  width: auto;
  opacity: 1;
}

.tooltip__info--main-container {
  position: absolute;
  visibility: hidden;
  z-index: 9999;
  color: white;
  opacity: 0;
  transition: all 0.3s ease-out;
}

/* arrow-box main style */
.tooltip__arrow--box {
  width: 100%;
  height: auto;
  position: relative;
  padding: 0 16px;
  text-align: center;
  background-color: $TOOLTIP_BG;
  border-radius: 4px;
  white-space: nowrap;
  box-sizing: border-box;
}

.tooltip__arrow--box:after,
.tooltip__arrow--box:before {
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

/* tooltip TOP placement - Arrow on bottom */
.tooltip__arrow--placement-top:after,
.tooltip__arrow--placement-top:before {
  top: 100%;
  left: 50%;
}

.tooltip__arrow--placement-top:after {
  border-top-color: $TOOLTIP_BG;
  border-width: 8px;
  margin-left: -8px;
}

/* tooltip BOTTOM placement - Arrow on top */
.tooltip__arrow--placement-bottom:after,
.tooltip__arrow--placement-bottom:before {
  bottom: 100%;
  left: 50%;
}

.tooltip__arrow--placement-bottom:after {
  border-bottom-color: $TOOLTIP_BG;
  border-width: 8px;
  margin-left: -8px;
}

/* tooltip RIGHT placement - Arrow on the left */
.tooltip__arrow--placement-right:after,
.tooltip__arrow--placement-right:before {
  right: 100%;
  top: 50%;
}

.tooltip__arrow--placement-right:after {
  border-right-color: $TOOLTIP_BG;
  border-width: 8px;
  margin-top: -8px;
}

/* tooltip LEFT placement - Arrow on the right */
.tooltip__arrow--placement-left:after,
.tooltip__arrow--placement-left:before {
  left: 100%;
  top: 50%;
}

.tooltip__arrow--placement-left:after {
  border-left-color: $TOOLTIP_BG;
  border-width: 8px;
  margin-top: -8px;
}
</style>
